export default __webpack_public_path__ + "static/media/DecUnselectedDataSortIcon.7bf06308.svg";